export var UserRole = /*#__PURE__*/ function(UserRole) {
    UserRole["ADMIN"] = "admin";
    UserRole["CAST"] = "cast";
    UserRole["LEADER"] = "leader";
    UserRole["LEADER_BASIC"] = "leader-basic";
    UserRole["PUBLIC"] = "public";
    return UserRole;
}({});

//# sourceMappingURL=user.types.js.map